const selectors = {
  getEServicesList: state => state.eServices.get('eServices'),
  getUserInfo: state => state.eServices.get('userInfo')
};

export default selectors;
